import { Typography, TypographyProps } from '@mui/material';

import { DateFormat, i18nFormat } from 'utils/date.utils';

import { useLocale } from 'hooks/useLocale';

interface Props extends TypographyProps {
  zonedStartDate: Date;
  updatedZonedEndDate: Date;
}

//Multi-day events are events that start on a specific date and end after 6AM of the next day or any other time the days after.

//Thu 7 Dec 9:00PM - Fri 8 Dec 6:01AM = multi-day
//7 Dec - 8 Dec - Starting from 9:00PM

//Thu 7 Dec 9:00PM - Sat 9 Dec 2:00AM = multi-day
//7 Dec - 8 Dec - Starting from 9:00PM

//Thu 7 Dec 9:00PM - Sat 9 Dec 6:01AM = multi-day
//7 Dec - 9 Dec - Starting from 9:00PM

const MultiDayDateTime = ({
  zonedStartDate,
  updatedZonedEndDate,
  ...props
}: Props) => {
  const { locale } = useLocale();

  const daysFormatted = [
    i18nFormat(zonedStartDate, DateFormat.ShortWithoutDayDate[locale], locale),
    i18nFormat(
      updatedZonedEndDate,
      DateFormat.ShortWithoutDayDate[locale],
      locale,
    ),
  ].join(' - ');

  return (
    <Typography
      variant="extraSmall"
      {...props}
      sx={[
        {
          color: 'global01.400',
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {daysFormatted}
    </Typography>
  );
};

export default MultiDayDateTime;
